import { useEffect, useState } from "react";

export function useUrlReachable(url, timeoutMs = 5000) {
    const [status, setStatus] = useState("checking");

    useEffect(() => {
        if (!url) return setStatus("unreachable");

        const link = document.createElement("link");
        link.rel = "prefetch"; // causes a network fetch
        link.href = url;

        let timeout = setTimeout(() => {
            setStatus("unreachable");
            cleanup();
        }, timeoutMs);

        link.onload = () => {
            clearTimeout(timeout);
            setStatus("reachable");
            cleanup();
        };

        link.onerror = () => {
            clearTimeout(timeout);
            setStatus("unreachable");
            cleanup();
        };

        document.head.appendChild(link);

        function cleanup() {
            link.onload = null;
            link.onerror = null;
            if (link.parentNode) link.parentNode.removeChild(link);
        }

        return cleanup;
    }, [url, timeoutMs]);

    return status;
}
